var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"lunch_item",attrs:{"src":require("../../../assets/images/activity/202107/1.png")}}),_vm._v(" "),_c('img',{staticClass:"lunch_btn",attrs:{"src":require("../../../assets/images/activity/202107/btn.png")},on:{"click":function($event){return _vm.reLaunchVip()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1db000","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/buycardgift/lunchbox.vue
// module id = null
// module chunks = 